import { MainMenuLink, SwitchLink } from '@type/header-types';
import {
  CurrencyDollarIcon, Squares2X2Icon, BriefcaseIcon, UserGroupIcon,
  ChatBubbleLeftIcon,
} from '@heroicons/react/20/solid';

// MAIN MENU LINKS
// forRole:
// NONE - for all, when they are not logged-in
// USER - for authenticated users with role 'USER'
// COMPANY - for authenticated users with role 'COMPANY'

// type:
// symfony - link to symfony route
// react - link to react route
// external - link to external route

// forSection
// TALENT - Represents the talent-related section.
// HIRE - Represents the hiring-related section.
// *******************************************************************
export const mainMenuLinks: MainMenuLink[] = [
  { // job list page
    route: '/job/list',
    type: 'react',
    label: 'header.label.jobs',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    icon: Squares2X2Icon,
    dataTestId: 'navbar-job-list',
  },
  {
    route: '/cv/search',
    type: 'react',
    label: 'header.label.cv_search',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    icon: UserGroupIcon,
  },
  {
    route: '/my-jobs',
    label: 'hire.menu',
    type: 'react',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    icon: BriefcaseIcon,
    dataTestId: 'navbar-cv-search',
    children: [
      { // company job list page
        route: '/my-jobs',
        label: 'header.label.jobs.v2',
        type: 'react',
        forSection: ['TALENT', 'HIRE'],
        onlyMobile: false,
        dataTestId: 'navbar-my-jobs',
      },
      {
        // add job
        route: '/job-add/edit',
        label: 'header.label.add_jobs',
        type: 'react',
        forSection: ['TALENT', 'HIRE'],
        onlyMobile: false,
        dataTestId: 'navbar-add-job',
        hasDiscount: true,
      },
      {
        // services page
        route: '/company/offer',
        label: 'header.label.pricing',
        type: 'react',
        forSection: ['TALENT', 'HIRE'],
        onlyMobile: false,
        dataTestId: 'navbar-services',
      },
    ],
  },
  { // cv worth page
    route: '/salaries',
    label: 'global.label.salaries',
    type: 'react',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    onlyDesktop: true,
    icon: CurrencyDollarIcon,
    dataTestId: 'navbar-salaries',
  },
  {
    route: '/bestie',
    type: 'react',
    label: 'header.label.bia',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    icon: ChatBubbleLeftIcon,
  },
];


// SWITCH LINK - between company and user
// *******************************************************************
export const switchLink: SwitchLink = {
  notAuth: { // to add job
    route: '/job-add/edit',
    label: 'header.label.add_jobs',
  },
  authUser: { // change to company account
    route: 'account_user_type',
    label: 'header.switch.hire',
  },
  authCompany: { // change to user account
    route: 'account_user_type',
    label: 'header.switch.work',
  },
};
